import { z } from 'zod';
import { paginatedQuerySchema } from '~/util/types/api';

export const dailyStatsParamsSchema = z
    .object({
        reviewer: z.uuidv4().nullable().default(null),
    })
    .extend(
        paginatedQuerySchema({ default_per_page: 31, max_per_page: 3650 })
            .shape,
    );

export type dailyStatsParams = z.input<typeof dailyStatsParamsSchema>;
export const defaultDailyStatsParams = dailyStatsParamsSchema.parse({});

export const moderatorLeaderboardParamsSchema = z.object({
    since: z.string().nullable().default(null),
    until: z.string().nullable().default(null),
    only_active: z.boolean().default(true),
    include_hidden_reviewers: z.boolean().default(false),
    reviewer_id: z.uuidv4().nullable().default(null),
});
export type moderatorLeaderboardParams = z.input<
    typeof moderatorLeaderboardParamsSchema
>;
export const defaultModeratorLeaderboardParams =
    moderatorLeaderboardParamsSchema.parse({});

export const statsParamsSchema = dailyStatsParamsSchema
    .extend(moderatorLeaderboardParamsSchema.shape)
    .extend({
        tab: z
            .enum(['daily', 'leaderboard', 'records', 'submissions'])
            .default('leaderboard'),
    });
export type StatsParams = z.input<typeof statsParamsSchema>;
export const defaultStatsParams = statsParamsSchema.parse({});
